export default __webpack_public_path__ + "static/media/screen2.ff1d9f39.png";